// extracted by mini-css-extract-plugin
module.exports = {"container":"Chart_Zodiac_Board_container__2CYi_"};